import React from 'react';
import { StepContainer } from '../StepContainer';
import { FormSection } from './form/formSection';
import { FormItem } from './form/formItem';

interface VRDStepProps {
  data: any;
  onChange: (data: any) => void;
  onNext: () => void;
  onBack: () => void;
}

export const VRDStep: React.FC<VRDStepProps> = ({
  data = {
    raccordements: {},
    terrassement: {},
    eauxPluviales: {},
    divers: {}
  },
  onChange,
  onNext,
  onBack
}) => {
  const updateSection = (section: string, key: string, value: any) => {
    onChange({
      ...data,
      [section]: {
        ...data[section],
        [key]: value
      }
    });
  };

  return (
    <StepContainer
      title="Voirie et Réseaux Divers (VRD)"
      description="Détaillez les travaux de raccordement et d'aménagement extérieur"
      onNext={onNext}
      onBack={onBack}
    >
      <div className="space-y-6">
        <FormSection
          title="1. Raccordements"
          description="Raccordements aux différents réseaux"
        >
          <div className="space-y-4">
            <FormItem
              label="Raccordement à l'eau potable"
              value={data.raccordements?.eauPotable || { selected: false }}
              onChange={(value) => updateSection('raccordements', 'eauPotable', value)}
              withDistance
            />
            <FormItem
              label="Raccordement au réseau d'électricité"
              value={data.raccordements?.electricite || { selected: false }}
              onChange={(value) => updateSection('raccordements', 'electricite', value)}
              withDistance
            />
            <FormItem
              label="Raccordement au réseau de gaz"
              value={data.raccordements?.gaz || { selected: false }}
              onChange={(value) => updateSection('raccordements', 'gaz', value)}
              withDistance
            />
            <FormItem
              label="Raccordement au réseau d'assainissement"
              value={data.raccordements?.assainissement || { selected: false }}
              onChange={(value) => updateSection('raccordements', 'assainissement', value)}
              withDistance
            />
            <FormItem
              label="Installation d'une fosse septique"
              value={data.raccordements?.fosseSeptique || { selected: false }}
              onChange={(value) => updateSection('raccordements', 'fosseSeptique', value)}
            />
            <FormItem
              label="Installation d'une micro-station d'épuration"
              value={data.raccordements?.microStation || { selected: false }}
              onChange={(value) => updateSection('raccordements', 'microStation', value)}
            />
          </div>
        </FormSection>

        <FormSection
          title="2. Terrassement"
          description="Travaux de terrassement et d'accès"
        >
          <div className="space-y-4">
            <FormItem
              label="Création ou remise à niveau d'un chemin d'accès"
              value={data.terrassement?.cheminAcces || { selected: false }}
              onChange={(value) => updateSection('terrassement', 'cheminAcces', value)}
              withLength
            />
            <FormItem
              label="Terrassement pour parking ou garage"
              value={data.terrassement?.parking || { selected: false }}
              onChange={(value) => updateSection('terrassement', 'parking', value)}
              withSurface
            />
            <FormItem
              label="Fouilles pour fondations ou réseaux"
              value={data.terrassement?.fouilles || { selected: false }}
              onChange={(value) => updateSection('terrassement', 'fouilles', value)}
              withVolume
            />
          </div>
        </FormSection>

        <FormSection
          title="3. Gestion des eaux pluviales"
          description="Systèmes de gestion des eaux de pluie"
        >
          <div className="space-y-4">
            <FormItem
              label="Installation de drains périphériques"
              value={data.eauxPluviales?.drains || { selected: false }}
              onChange={(value) => updateSection('eauxPluviales', 'drains', value)}
              withLength
            />
            <FormItem
              label="Création d'une tranchée d'infiltration"
              value={data.eauxPluviales?.trancheeInfiltration || { selected: false }}
              onChange={(value) => updateSection('eauxPluviales', 'trancheeInfiltration', value)}
              withLength
            />
            <FormItem
              label="Installation d'une cuve de récupération"
              value={data.eauxPluviales?.cuveRecuperation || { selected: false }}
              onChange={(value) => updateSection('eauxPluviales', 'cuveRecuperation', value)}
              withCapacity
            />
          </div>
        </FormSection>

        <FormSection
          title="4. Travaux divers"
          description="Autres travaux de VRD"
        >
          <div className="space-y-4">
            <FormItem
              label="Pose ou réparation de bordures"
              value={data.divers?.bordures || { selected: false }}
              onChange={(value) => updateSection('divers', 'bordures', value)}
              withLength
            />
            <FormItem
              label="Création ou réparation de trottoirs"
              value={data.divers?.trottoirs || { selected: false }}
              onChange={(value) => updateSection('divers', 'trottoirs', value)}
              withLength
            />
            <FormItem
              label="Pose de regards ou d'avaloirs"
              value={data.divers?.regards || { selected: false }}
              onChange={(value) => updateSection('divers', 'regards', value)}
              withQuantity
            />
          </div>
        </FormSection>
      </div>
    </StepContainer>
  );
};

export default VRDStep;
